import(/* webpackMode: "eager" */ "/vercel/path1/components/client/play-demo-cta.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/client/success-scorecard-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path1/components/client/text-transition.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/.pnpm/next@15.3.3_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.77.4/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/vercel/path1/node_modules/.pnpm/next@15.3.3_@opentelemetry+api@1.9.0_react-dom@19.1.0_react@19.1.0__react@19.1.0_sass@1.77.4/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/5-benefits-of-client-loyalty-reward-schemes.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/5-marketing-mistakes-to-avoid.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/5-proven-strategies-for-attracting-more-clients.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/7-ways-to-boost-your-salon-sales-this-valentines-day.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/advance-payment.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Attract-Desktop.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/automations-how-to-buy-back-time.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/barber-haircut.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/blog-online-booking.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Brilliant-reward.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Christmas Bookings .png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/closedbutawesome.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Contingency.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/cutting-hair.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/dont-forget-speech-bubble.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/double-clients-paid-ads.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/double-clients-referrals.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/double-clients-reviews.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/drawing-of-charts.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/elevating-client-experiences-with-concierge-digital-consultation-forms.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/elevating-the-new-client-experience-the-power-of-digital-concierge-forms.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/empty-chair.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/google-business-profile.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/google-reviews-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/hair-stylist-using-tablet.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/happyclient.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/how-to-build-and-maintain-a-strong-clientele-in-the-hairdressing-industry.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/how-to-go-paperless-in-your-salon.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/how-to-reduce-no-shows-and-cancellations-in-your-salon.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/how-to-safely-store-client-details-in-salons-streamlining-with-digital-consultation-forms.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/how-to-take-a-thorough-client-consultation-utilizing-digital-consultations-for-salon-owners.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/how-to-transform-your-salon-with-digital-consultation-forms.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/increase-your-january-sales-5-must-try-marketing-strategies-for-your-salon.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/know-your-numbers.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/lady-at-reception-desk.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Leaderboard_Header_image.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/loyalty-reward-scheme-pitfalls-to-avoid.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/loyalty-reward-schemes-to-retain-clients.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/marketing-campaigns.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/maximise-your-salons-bookings-this-christmas-season.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/maximising-client-retention.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/new-client-retention-a-5-step-framework-for-salons.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/new-year.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/november-campaigns.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Nurture.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/online-booking-mobile.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/online-booking.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/paper-diary.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/person-using-laptop-and-phone.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Proud_barber.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/rebooking-why.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Reconnect.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/review-us-on-google.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/revolutionising-beauty-salon-consultations-the-power-of-digital-forms.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/revolutionising-the-salon-industry-the-power-of-digital-consultation-forms.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Salon-Image.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/Sell-more-retail-desktop.webp");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/success-with-salon-software-the-faster-way-forward.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/the-power-of-digital-consultation-forms-for-salon-consent-a-game-changer-for-salon-professionals.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/the-ultimate-guide-to-social-media-marketing-for-hair-salons.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/transform-your-walk-in-client-experience.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/ultimate-christmas-bookings-campaign-banner.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/unleash-your-teams-sales-potential-boosting-sales-at-your-salon.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/wait-list.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/waiting-for-train.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/why-aftercare-messages-help-to-build-professional-salons.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/win-back-non-returning-clients.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/woman-sitting-on-floor-and-leaning-on-couch-using-laptop.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/woman-wearing-mud-mask.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/blog/your-business-resolutions-for-2024.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/Colin.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/campaign-result.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/diary-booking.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/marketing-email.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/new_desktop_hero.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/new_mobile_hero.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/online-booking/olb-hero.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/sales-summary.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salon-success-quiz.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/andrew-bayliss-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/caisters-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/cruz-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/face-facts-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/finn-and-co-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/hair-pro-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/honeys-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/john-richards-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/matthew-clulee-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/merluza-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/michael-todd-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/pamper-suite-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/paul-watts-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/images/salons/timba-logo.png");
;
import(/* webpackMode: "eager" */ "/vercel/path1/public/landing/webinar/1.png");
